export class PostContactFonction {
  fonction?: string;
  contactID?: number;
  flagDelete?: number;
}
